import api from ".."

const onboardResolve = api.injectEndpoints({
  endpoints: (build) => ({
    getOnboardedInvestorsKycData: build.query({
      query: ({ id }) => ({
        url: `/wealthPartner/onboardResolve/kyc/data/${id}`,
        method: "GET",
      }),
    }),
    resolveOnboardedBusinessDetails: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/save_company_details/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveOnboardedBusinessDetailsManually: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/company_details/manually/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveBusinessAdditionalDetailsOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/business_additional_details/${id}`,
        method: "POST",
        body,
      }),
    }),

    resolveUpdateBankDetailsOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/update/bank/details/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveFetchBankDetailsOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/bank/fetch/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveBusinessSignatoryOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/update/business/signatory/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveAuthorityLetterOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/upload/authority/letter/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveIcdAgreementOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/update/icd/agreement/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveCompleteOnboardingInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/final/submission/${id}`,
        method: "POST",
        body,
      }),
    }),
    resolveQueryStepsOnboardedInvestor: build.query({
      query: ({ id }) => ({
        url: `/wealthPartner/onboardResolve/resolve/query/steps/${id}`,
        method: "GET",
      }),
    }),
    updateResolveInvestorOnboardedStep: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboardResolve/update/step/${id}`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetOnboardedInvestorsKycDataQuery,
  useResolveOnboardedBusinessDetailsMutation,
  useResolveOnboardedBusinessDetailsManuallyMutation,
  useResolveBusinessAdditionalDetailsOnboardedInvestorMutation,
  useResolveFetchBankDetailsOnboardedInvestorMutation,
  useResolveUpdateBankDetailsOnboardedInvestorMutation,
  useResolveBusinessSignatoryOnboardedInvestorMutation,
  useResolveAuthorityLetterOnboardedInvestorMutation,
  useResolveIcdAgreementOnboardedInvestorMutation,
  useResolveCompleteOnboardingInvestorMutation,
  useLazyResolveQueryStepsOnboardedInvestorQuery,
  useUpdateResolveInvestorOnboardedStepMutation,
} = onboardResolve
